export default "__VITE_ASSET__5BwJRXZS__"